import { render, staticRenderFns } from "./create-conversation.vue?vue&type=template&id=3afceed6&scoped=true"
import script from "./create-conversation.vue?vue&type=script&lang=ts"
export * from "./create-conversation.vue?vue&type=script&lang=ts"
import style0 from "./create-conversation.vue?vue&type=style&index=0&id=3afceed6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afceed6",
  null
  
)

export default component.exports